import { GridColDef } from '@mui/x-data-grid-pro'
import { useConfirm } from 'hic-components'
import { useTranslation } from 'react-i18next'
import { DeleteAction } from 'src/app/components/data-grid-action-cell-item'
import { HicDataGridPro } from 'src/app/components/hic-vapor/datagrid/datagrid'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { keysOf } from 'src/utils/utils'

export type PaidInFullPendingDocumentsRow = {
  id: string
  numberExtended: string
  documentDate: Date
  totalAmount: number
  referenceDescription: string
}

type PaidInFullPendingDocumentsGridProps = {
  rows: PaidInFullPendingDocumentsRow[]
  onDelete: (documentId: string) => void
}

export const PaidInFullPendingDocumentsGrid = (props: PaidInFullPendingDocumentsGridProps) => {
  const { rows } = props

  const { t } = useTranslation()
  const formatDate = useFormatDate()
  const { formatTableCurrency } = useFormatCurrency()
  const { currency } = useTenant()
  const confirm = useConfirm()

  const fields = keysOf<PaidInFullPendingDocumentsRow>()

  const columns: GridColDef[] = [
    {
      field: fields('numberExtended'),
      minWidth: 130,
      maxWidth: 200,
      headerName: t('pms.accounting.documents.progressive'),
    },
    {
      field: fields('documentDate'),
      headerName: t('pms.accounting.documents.document_date'),
      type: 'date',
      minWidth: 100,
      maxWidth: 200,
      valueFormatter: ({ value }) => formatDate(value),
    },
    {
      field: fields('totalAmount'),
      headerName: t('commons.document_total'),
      type: 'number',
      minWidth: 130,
      maxWidth: 200,
      valueFormatter: ({ value }) => formatTableCurrency(value, currency),
    },
    {
      field: fields('referenceDescription'),
      headerName: t('commons.document_references'),
      flex: 1,
    },
    {
      field: 'actions',
      headerName: t('commons.table_actions'),
      type: 'actions',
      minWidth: 100,
      maxWidth: 150,
      getActions: (params) => {
        const row = params.row as PaidInFullPendingDocumentsRow
        return [
          <DeleteAction
            label={t('commons.delete')}
            onClick={() => {
              confirm({
                title: t('pms.accounting.documents.paid_in_full.cancellation_confirm_title'),
                message: t('pms.accounting.documents.paid_in_full.cancellation_configrm_message'),
                cancelButtonText: t('commons.no'),
                confirmButtonText: t('commons.yes'),
                onConfirm: () => props.onDelete(row.id),
              })
            }}
          />,
        ]
      },
    },
  ]

  return (
    <>
      <HicDataGridPro //
        columns={columns}
        rows={rows}
        autoHeight
        hideFooter
      />
    </>
  )
}
